import { customerApi } from "../../utils/apiConfig";

export const cleaningPlanInsert = (payload) => {
  return customerApi.post("/cleaningPlanInsert", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getPersonels = () => {
  return customerApi.get("/getPersonelForPlan", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const cleaningPlanUpdate = (payload) => {
  return customerApi.post("/cleaningPlanUpdate", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const cleaningPlanDelete = (payload) => {
  return customerApi.post("cleaningPlanDelete", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const cleaningPlanList = (payload) => {
  return customerApi.post("/cleaningPlanList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
